<template>
  <!--  <div data-app="true" class="v-application v-application&#45;&#45;is-rtl rounded">-->
  <!--    <div class="v-application&#45;&#45;wrap " style="min-height: 350px!important;">-->
  <div class="mt-0">
    <v-toolbar class="rounded" flat>
      <div class="border-0 row mb-0 justify-content-center">
        <h3
          class="card-title font-weight-bolder text-dark col-xxl-6 mb-0 text-center"
        >
          <v-icon color="#1BC5BD">mdi-notebook-multiple</v-icon>
          {{ $t("planning.title") }}
        </h3>
      </div>

      <template v-slot:extension>
        <v-tabs
          v-model="tabs"
          :show-arrows="$vuetify.breakpoint.smAndDown"
          grow
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab class="primary--text" href="#mobile-tabs-5-1">
            <v-icon class="me-2">mdi-update</v-icon>
            <b>{{ $t("tabs.reminder") }}</b>
          </v-tab>

          <v-tab class="primary--text" href="#mobile-tabs-5-2">
            <v-icon class="me-2">mdi-message-bulleted</v-icon>
            <b>{{ $t("tabs.notes") }}</b>
          </v-tab>

          <v-tab class=" " href="#mobile-tabs-5-3">
            <v-icon class="me-2">mdi-calendar-text</v-icon>
            <b>{{ $t("tabs.calendar") }}</b>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <div class="">
      <div class="">
        <v-tabs-items v-model="tabs">
          <v-tab-item value="mobile-tabs-5-1">
            <v-card flat>
              <Remember
                :plannings="plannings"
                @getRemember="$emit('getData')"
              />
            </v-card>
          </v-tab-item>

          <v-tab-item value="mobile-tabs-5-2">
            <v-card>
              <div class="container">
                <div class="timeline timeline-3 mt-5">
                  <div
                    class="timeline-items"
                    style="max-height: 40rem; overflow-y: scroll"
                  >
                    <div
                      v-for="(note, index) in plannings"
                      v-if="note.type === 'notes'"
                      :key="index"
                      class="timeline-item mx-8 border-right-0 px-0"
                    >
                      <div class="timeline-content">
                        <div
                          class="d-flex align-items-center justify-content-between mb-3"
                        >
                          <div class="mr-2">
                            <div class="d-flex flex-row w-100">
                              <v-text-field
                                v-if="note.inEditMode"
                                v-model="note.title"
                                class="form-control form-control-lg form-control-solid p-0 d-inline-block"
                              ></v-text-field>
                              <v-text-field
                                v-else
                                v-model="note.title"
                                class="form-control form-control-lg form-control-solid p-0 d-inline-block"
                                readonly
                              ></v-text-field>
                              <div class="pt-1">
                                <span style="font-size: 8pt; color: #a1a1a1">{{
                                  $t("notes.creationDate")
                                }}</span>
                                <span
                                  class="label label-light-success font-weight-bolder label-inline ml-2"
                                  style="white-space: nowrap"
                                >
                                  {{ note.updated_at | longDate }}</span
                                >
                              </div>
                              <!--                      <span v-if="note.inEditMode" class="label label-light-info font-weight-bolder label-inline ml-2" @click="submitChanges(index)" style="cursor: pointer;margin-top: 1.8rem;white-space: nowrap">{{ $t('common.save') }}</span>-->
                              <v-btn
                                v-if="note.inEditMode"
                                :loading="loading"
                                class="submit-btn"
                                style="cursor: pointer; white-space: nowrap"
                                @click="submitChanges(note)"
                                >{{ $t("common.save") }}
                              </v-btn>
                              <!--                      <span v-if="note.inEditMode" class="label label-light-danger font-weight-bolder label-inline ml-2" @click="cancelEdit(index)" style="cursor: pointer;margin-top: 1.8rem;white-space: nowrap">{{ $t('common.cancel') }}</span>-->
                              <v-btn
                                v-if="note.inEditMode"
                                class="btn-cancel"
                                style="cursor: pointer; white-space: nowrap"
                                @click="cancelEdit(note)"
                                >{{ $t("common.cancel") }}
                              </v-btn>
                            </div>
                          </div>
                          <div
                            class="dropdown ml-2"
                            :data-original-title="$t('actions.quickActions')"
                            data-placement="left"
                            data-toggle="tooltip"
                            title=""
                          >
                            <EditAndDeleteBtn
                              :inEditMode="note.inEditMode"
                              @editMode="note.inEditMode = true"
                              @removeNote="removeNote(note)"
                            ></EditAndDeleteBtn>
                          </div>
                        </div>

                        <textarea
                          v-if="note.inEditMode"
                          v-model="note.description"
                          class="form-control form-control-lg form-control-solid"
                          :placeholder="$t('notes.writeMessage')"
                          rows="3"
                        ></textarea>

                        <textarea
                          v-else
                          v-model="note.description"
                          class="form-control form-control-lg form-control-solid"
                          :placeholder="$t('notes.writeMessage')"
                          readonly
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <!--end::تایم لاین-->
                <div class="separator separator-dashed my-4"></div>

                <form class="form mt-4">
                  <div class="form-group">
                    <v-text-field
                      v-model="title"
                      class="form-control form-control-lg form-control-solid"
                      :placeholder="$t('notes.titlePlaceholder')"
                    ></v-text-field>
                    <textarea
                      v-model="description"
                      class="form-control form-control-lg form-control-solid"
                      :placeholder="$t('notes.writeMessage')"
                      rows="3"
                    ></textarea>
                  </div>
                  <div v-if="errors.length" class="mr-3">
                    <ul>
                      <li v-for="(item, i) in errors" class="text-danger">
                        {{ item[0] }}
                      </li>
                    </ul>
                  </div>
                  <div class="row">
                    <div class="col">
                      <v-btn
                        :disabled="!title || !description"
                        :loading="loading"
                        class="btn-add-with-text"
                        @click="addNote"
                      >
                        <i class="fa fa-sticky-note icon-lg"></i>

                        {{ $t("notes.addNote") }}
                      </v-btn>
                    </div>
                  </div>
                </form>
              </div>
            </v-card>
          </v-tab-item>

          <v-tab-item style="background-color: #eef0f8" value="mobile-tabs-5-3">
            <!--end::تایم لاین-->
            <div class="mt-5">
              <Calender :plannings="plannings" @getData="$emit('getData')" />
            </div>
          </v-tab-item>
        </v-tabs-items>
        <!--begin::تایم لاین-->
      </div>
    </div>
  </div>
  <!--  </div>-->
  <!--  </div>-->
</template>

<script>
import Calender from "@/view/layout/home/Calender";
import Calenders from "@/view/pages/vuetify/Calendars";
import Remember from "@/view/pages/Notes/Remember";
import EditAndDeleteBtn from "@/view/pages/Notes/EditAndDeleteBtn";

export default {
  name: "Notes",
  props: ["plannings"],
  components: { EditAndDeleteBtn, Remember, Calender, Calenders },
  data() {
    return {
      title: null,
      description: null,
      loading: false,
      tabs: null,
      addNoteText: "",
      addNoteTitle: "",
      errors: [],
    };
  },

  methods: {
    submitChanges(note) {
      this.loading = true;
      this.requestApiPut(`user/planning/${note.id}`, {
        title: note.title,
        description: note.description,
        method: "PUT",
      })
        .then(({ data }) => {
          this.loading = false;
          this.$toast.success(this.$t("notes.updatedSuccess"));
          note.inEditMode = false;
          this.$emit("getData");
        })
        .catch(({ response }) => {
          this.loading = false;
        });
    },
    cancelEdit(note) {
      note.inEditMode = false;
    },
    addNote() {
      this.loading = true;
      this.requestApiPost("user/create-note", {
        title: this.title,
        description: this.description,
      })
        .then(({ data }) => {
          this.title = null;
          this.description = null;
          this.loading = false;
          this.errors = [];
          this.$toast.success(this.$t("notes.addedSuccess"));
          this.$emit("getData");
        })
        .catch(({ response }) => {
          this.loading = false;
          this.errors = response.data.errors;
        });
    },
    async removeNote(note) {
      if (await this.$modal.yesNo(this.$t("common.confirmDelete"))) {
        this.$modal.showLoading();
        this.requestApiDelete(`user/planning/${note.id}`)
          .then(({ data }) => {
            this.$emit("getData");
            this.$modal.hideLoading();
            this.$toast.success(this.$t("common.deletedSuccess"));
          })
          .catch(({ response }) => {
            this.$modal.hideLoading();
          });
      }
    },
  },

  watch: {
    plannings: {
      handler() {
        localStorage.setItem("user_notes", JSON.stringify(this.plannings));
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.left-align {
  text-align: left;
}

.v-toolbar__content,
.v-toolbar__content {
  background-color: red !important;
}
</style>
